import Modal from "components/Modal";
import ReactCodeMirror from "@uiw/react-codemirror";
import { oneDark } from "@codemirror/theme-one-dark";
import { EditorView } from "@codemirror/view";
import Button from "components/Button";
import { ClipboardCopyIcon } from "@heroicons/react/outline";
import Toaster from "components/Toaster";
import { formatJson } from "utils/jsonUtils";

const codeViewerTheme = EditorView.theme({
  "&": { backgroundColor: "#001531" },
  ".cm-content": { backgroundColor: "#001531" },
  ".cm-scroller": { backgroundColor: "#001531" },
  ".cm-gutters": { backgroundColor: "#001531 !important", borderRight: "1px solid #001531" },
  ".cm-gutterElement": { backgroundColor: "#001531", borderRight: "1px solid #001531" },
  ".cm-activeLineGutter": { backgroundColor: "#001531", borderRight: "1px solid #001531" },
  ".cm-gutterElement.cm-activeLineGutter": { backgroundColor: "#001531", borderRight: "1px solid #001531" },
  ".cm-activeLine": { backgroundColor: "rgba(255, 255, 255, 0.05)" },
}, { dark: true });

interface ViewJobResponseModalProps {
  isOpen: boolean;
  onClose: () => void;
  urlData: {
    id: string;
    url: string;
    response?: any;
  } | null;
}

export const ViewJobResponseModal = ({
  isOpen,
  onClose,
  urlData,
}: ViewJobResponseModalProps) => {
  // DP results arrive as the raw body string (CSV, markdown, HTML…); crawler results as objects.
  const previewContent = typeof urlData?.response === "string"
    ? formatJson(urlData.response)
    : urlData?.response
      ? JSON.stringify(urlData.response, null, 2)
      : "No data available";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(previewContent);
      Toaster.success('Result copied to clipboard');
    } catch (error) {
      console.error('Failed to copy:', error);
      Toaster.error('Failed to copy to clipboard');
    }
  };

  if (!isOpen || !urlData) return null;

  return (
    <Modal
      headline="Preview"
      onClose={onClose}
      showOverflow
      closeOnEscapeKey
      closeOnClickAway
    >
      <div className="m-4" style={{ width: 'calc(100vw - 8rem)', maxWidth: '1200px' }}>
        <div className="bg-[#001531] rounded-lg overflow-hidden border border-[#00244b] relative">
          <button
            onClick={handleCopy}
            className="absolute top-3 right-3 z-10 p-2 text-gray-400 hover:text-white transition-colors"
            title="Copy to clipboard"
          >
            <ClipboardCopyIcon className="h-5 w-5" />
          </button>
          <div className="px-4 pb-4">
            <ReactCodeMirror
              value={previewContent}
              editable={false}
              theme={oneDark}
              height="60vh"
              extensions={[EditorView.lineWrapping, codeViewerTheme]}
              basicSetup={{
                lineNumbers: true,
                foldGutter: false,
                dropCursor: false,
                allowMultipleSelections: false,
                indentOnInput: false,
                bracketMatching: true,
                closeBrackets: false,
                autocompletion: false,
                rectangularSelection: false,
                highlightSelectionMatches: false,
                searchKeymap: false,
              }}
            />
          </div>
        </div>
        <div className="pt-4 flex justify-end">
          <Button text="close" onClick={onClose}/>
        </div>
      </div>
    </Modal>
  );
};

export default ViewJobResponseModal;
